import { create } from 'zustand';

/**
 * Work the URL can't rebuild, so the automatic reload on a route change would
 * drop it. This was a list of paths while a quiz had a page of its own; now it
 * is played inside a card on a storefront, and no path can tell a page with a
 * quiz in progress from the same page idle. So the quiz says so itself.
 *
 * Getting it wrong is silent in both directions: too loose and someone loses a
 * half-finished quiz, too tight and a stale tab never updates.
 */
interface HeldWorkState {
  holders: number;
  hold: () => () => void;
}

export const useHeldWork = create<HeldWorkState>((set, get) => ({
  holders: 0,
  hold: () => {
    set({ holders: get().holders + 1 });
    let released = false;
    return () => {
      if (released) return;
      released = true;
      set({ holders: Math.max(0, get().holders - 1) });
    };
  },
}));

export function isReloadUnsafe(): boolean {
  return useHeldWork.getState().holders > 0;
}
